import React from "react";

const DashboardTab = () => {
  // Mock data (replace with your fetched API data later)
  const cowData = { qty: 146.1, fat: 4.2, snf: 8.5, rate: 42.5, amount: 6200 };
  const buffData = { qty: 38.5, fat: 6.5, snf: 9.0, rate: 55.0, amount: 2100 };
  const totalLiters = cowData.qty + buffData.qty;
  const totalAmount = cowData.amount + buffData.amount;

  const expenses = {
    feed: { expense: 1200, debt: 300 },
    advance: { expense: 5000, debt: 2000 },
    total: { expense: 6200, debt: 2300 },
  };

  const formatCurrency = (value) =>
    `₹${value.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`;

  return (
    <div style={{ padding: "10px", fontFamily: "sans-serif" }}>
      {/* Section: संकलन */}
      <div
        style={{
          border: "2px solid #4CAF50",
          borderRadius: "8px",
          padding: "10px",
          marginBottom: "15px",
        }}
      >
        <h2 style={{ marginBottom: "10px", color: "#2E7D32" }}>संकलन</h2>

        {/* Cow Card */}
        <div style={cardStyle} >
          <Row label="गाय Qty" value={cowData.qty} />
          <Row label="Fat %" value={cowData.fat} />
          <Row label="SNF %" value={cowData.snf} />
          <Row label="दर" value={formatCurrency(cowData.rate)} />
          <Row label="रक्कम" value={formatCurrency(cowData.amount)} bold />
        </div>

        {/* Buff Card */}
        <div style={cardStyle}>
          <Row label="म्हैस Qty" value={buffData.qty} />
          <Row label="Fat %" value={buffData.fat} />
          <Row label="SNF %" value={buffData.snf} />
          <Row label="दर" value={formatCurrency(buffData.rate)} />
          <Row label="रक्कम" value={formatCurrency(buffData.amount)} bold />
        </div>

        {/* Total Row */}
        <div style={{ ...cardStyle, backgroundColor: "rgba(191, 239, 195, 1)" }}>
          <Row label="एकूण लिटर्स" value={totalLiters} bold />
          <Row label="एकूण रक्कम" value={formatCurrency(totalAmount)} bold />
        </div>
      </div>

      {/* Section: खर्च व देणी बाकी */}
      <div
        style={{
          border: "2px solid #4CAF50",
          borderRadius: "8px",
          padding: "10px",
        }}
      >
        <h2 style={{ marginBottom: "10px", color: "#2E7D32" }}>खर्च व देणी</h2>

        {/* खाद्य व औषधे */}
        <div style={cardStyle}>
          <Row label="खर्च (खाद्य व औषधे)" value={formatCurrency(expenses.feed.expense)} />
          <Row label="देणे बाकी (खाद्य व औषधे)" value={formatCurrency(expenses.feed.debt)} />
        </div>

        {/* अडवांस */}
        <div style={cardStyle}>
          <Row label="खर्च (अडवांस)" value={formatCurrency(expenses.advance.expense)} />
          <Row label="देणे बाकी (अडवांस)" value={formatCurrency(expenses.advance.debt)} />
        </div>

        {/* एकूण खर्च व देणी */}
        <div style={{ ...cardStyle, backgroundColor: "rgba(117, 202, 255, 0.44)" }}>
          <Row label="एकूण खर्च" value={formatCurrency(expenses.total.expense)} bold />
          <Row label="एकूण देणे बाकी" value={formatCurrency(expenses.total.debt)} bold />
        </div>
      </div>
    </div>
  );
};

// Card style
const cardStyle = {
  border: "1px solid rgba(66, 65, 65, 1)",
  backgroundColor: "rgba(241, 255, 184, 0.77)",
  borderRadius: "10px",
  padding: "8px 10px",
  marginBottom: "15px",
  // boxShadow: "1px 4px 6px rgba(27, 20, 20, 0.99)",
  boxShadow: "rgba(27, 20, 20, 0.99) 3px 7px 6px",
};

// Row component
const Row = ({ label, value, bold }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      fontWeight: bold ? "bold" : "normal",
      padding: "2px 0",
      borderBottom: "1px solid #eee",
    }}
  >
    <span>{label}</span>
    <span>{value}</span>
  </div>
);

export default DashboardTab;
